<template>
    <p>Are you sure you want to delete this State?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { type IClient } from '@app/purchase/client/models/Client';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { useClientRepository } from '@app/purchase/client/repositories/useClientRepository';

const props = defineProps({
    item: {
        type: Object as PropType<IClient>,
        required: true,
    },
});

const destroy = useClientRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
